export default "__VITE_ASSET__BSYGyulU__"